const IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_swift-toilet-pro/artifacts/cbhny6af_IMG_20220522_102009_114.jpg",
    label: "Blauwe hexagon · detail",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_swift-toilet-pro/artifacts/qhb3bu2l_IMG_20210617_231125_001.jpg",
    label: "Strak en modern",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_swift-toilet-pro/artifacts/lhs4xq6e_IMG_20240211_231751_199.jpg",
    label: "Marokkaans tegelwerk",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_swift-toilet-pro/artifacts/7vrcvbfg_IMG_20240211_232022_804.jpg",
    label: "Marmeren afwerking",
  },
];

export default function Gallery() {
  return (
    <section
      id="werk"
      className="bg-slate-50 py-20 lg:py-28"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-orange-500">
            Recent werk
          </p>
          <h2 className="font-display font-bold mt-3 text-4xl sm:text-5xl tracking-tight text-slate-900">
            Toiletten waar wij{" "}
            <span className="text-blue-700">trots op</span> zijn.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Van strak en modern tot warm en natuurlijk — kies de stijl die bij
            jouw huis past. Wij denken vrijblijvend mee.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 grid-rows-2 gap-4 sm:gap-5 h-[640px] sm:h-[720px]">
          <div className="relative col-span-2 row-span-2 rounded-2xl overflow-hidden group" data-testid="gallery-item-0">
            <img
              src={IMAGES[0].src}
              alt={IMAGES[0].label}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black/70 to-transparent">
              <div className="font-display font-semibold text-white text-2xl">
                {IMAGES[0].label}
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden group" data-testid="gallery-item-1">
            <img
              src={IMAGES[1].src}
              alt={IMAGES[1].label}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
              <div className="font-display font-semibold text-white text-lg">
                {IMAGES[1].label}
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden bg-blue-700 text-white p-6 sm:p-8 flex flex-col justify-between" data-testid="gallery-cta-card">
            <div>
              <div className="text-xs uppercase tracking-widest text-blue-200 font-bold">
                100% Vakwerk
              </div>
              <div className="mt-2 font-display font-bold text-2xl sm:text-3xl leading-tight">
                Ook benieuwd hoe jouw toilet eruit kan zien?
              </div>
            </div>
            <a
              href="https://wa.me/31615460576"
              target="_blank"
              rel="noreferrer"
              className="mt-4 inline-flex items-center justify-center h-11 px-5 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold transition-colors w-fit"
              data-testid="gallery-cta-btn"
            >
              App nu
            </a>
          </div>

          <div className="relative rounded-2xl overflow-hidden group" data-testid="gallery-item-2">
            <img
              src={IMAGES[2].src}
              alt={IMAGES[2].label}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
              <div className="font-display font-semibold text-white text-lg">
                {IMAGES[2].label}
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden group" data-testid="gallery-item-3">
            <img
              src={IMAGES[3].src}
              alt={IMAGES[3].label}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
              <div className="font-display font-semibold text-white text-lg">
                {IMAGES[3].label}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
